import React, { useState } from "react";
const VideoPlayer = ({videoListData}) => {

  const [show, setShow] = useState(videoListData[0]); // Initialize with the first video

  const handleVideoSelect = (video) => {
    setShow(video);
  };
  return (
    <div className="grid lg:grid-cols-8 w-full lg:space-x-10 space-y-8 lg:space-y-0">
      <div className="lg:col-span-5">
        <div className="h-[450px] bg-gradient-to-r from-[#1e2024] to-[#23272b] p-4 rounded-lg shadow-shadowOne">
          {show &&
            show.url &&
            show.thumbnail &&
            show.title &&
            show.subTitle && (
              <video
                className="h-full w-full object-fill"
                poster={show.thumbnail}
                src={show.url}
                controls
                muted
                controlsList="nodownload"
              />
            )}
        </div>
        <h3 className="mt-3 text-white font-semibold text-lg lg:text-xl">{show.title}</h3>
        <span className="text-secondaryColor font-light capitalize tracking-wide">
          {show.subTitle}
        </span>
      </div>
      <div className="lg:col-span-3 h-[450px] bg-gradient-to-r from-[#1e2024] to-[#23272b] p-4 rounded-lg shadow-shadowOne overflow-x-hidden overflow-y-scroll">
        <ul>
          {videoListData.map((video, index) => (
            <li
              className="flex space-x-3 w-full cursor-pointer group "
              key={index}
              onClick={() => handleVideoSelect(video)}
            >
              <div className="mb-3 h-[100px] w-[45%]">
                <img
                  src={video.thumbnail}
                  className="h-full w-full object-cover rounded-lg"
                  alt={video.title}
                />
              </div>
              <div className="w-[55%]">
                <h3 className="font-medium text-sm text-white capitalize">
                  {video.title}
                </h3>
                <span className="text-gray-400 text-xs font-normal group-hover:text-gray-200 capitalize tracking-wide duration-300">
                  {video.subTitle}
                </span>
              </div>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default VideoPlayer;

